import { render, staticRenderFns } from "./DrawerRecordTemplate.vue?vue&type=template&id=611dd580&"
import script from "./DrawerRecordTemplate.vue?vue&type=script&lang=js&"
export * from "./DrawerRecordTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports